<template>
    <div>
        <p>
            Priorizamos a utilização de fotos, mas ao mesmo tempo não abrimos mão das possibilidades
            criativas ao nosso alcance. Nossas ilustrações seguem o estilo de colagens, oferecendo
            ao trabalho de comunicação visual a abertura necessária para a criação de universos
            lúdicos e oníricos: é o casamento entre a fotografia e o abstrato das artes plásticas.
        </p>
    </div>
</template>

<script>
    export default {
        name: 'BrandBookIllustrations',
    };
</script>
